export const flyoutMixins = {
  props: {
    styles: {
      type: Object,
      required: true,
    },
  },
  methods: {
    toggleOptions() {
      this.isOpen = !this.isOpen;
    },
    showOptions() {
      this.isOpen = true;
    },
    closeOptions() {
      this.isOpen = false;
    },
    onButtonFocus() {
      this.showOptions();
    },
    onFocusIn() {
      this.showOptions();
    },
    onFocusOut(event) {
      const nav = this.$refs.flyoutNav;
      if (!nav.contains(event.relatedTarget)) {
        this.closeOptions();
      }
    },
    focusNextItem(currentIndex) {
      if (currentIndex < this.linkGroup.links.length - 1) {
        this.$refs.options.querySelectorAll("a")[currentIndex + 1].focus();
      }
    },
    focusPrevItem(currentIndex) {
      if (currentIndex > 0) {
        this.$refs.options.querySelectorAll("a")[currentIndex - 1].focus();
      }
    },
    close() {
      this.isOpen = false;
    },
  },
};
